import { countries } from '../data/countries';

/**
 * Gets the ISO country code for a country by its ID
 *
 * @param countryId - The country ID to look up
 * @returns The ISO 3166-1 alpha-2 country code (lowercase), or empty string if not found
 */
export function getIsoCodeByCountryId(countryId: number): string {
  return countries.find((c) => parseInt(c.id) === countryId)?.isoCode || '';
}
